import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { createRef } from 'react';
import { lsgPre } from '../../config/prefix.js';
import { addResizeCallback, removeResizeCallback } from '../../utils/windowEvents/ResizeEvents.js';
import { addScrollCallback, removeScrollCallback } from '../../utils/windowEvents/ScrollEvents.js';
import { HeaderContainerPresentation } from './HeaderContainerPresentation.js';

var HeaderContainerWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(HeaderContainerWrapper, _React$Component);
  var _super = _createSuper(HeaderContainerWrapper);
  function HeaderContainerWrapper(props) {
    var _this;
    _classCallCheck(this, HeaderContainerWrapper);
    _this = _super.call(this, props);
    _this.mainContainerRightTopRef = /*#__PURE__*/createRef();
    _this.mainContainerRightBottomRef = /*#__PURE__*/createRef();
    _this.checkMarginLeft = function (elementRef) {
      if (elementRef) {
        var marginLeftString = window.getComputedStyle(elementRef).marginLeft;
        var marginLeft = parseInt(marginLeftString.slice(0, marginLeftString.length - 2), 10);
        if (marginLeft && marginLeft > 64) {
          return true;
        }
      } else {
        return true;
      }
      return false;
    };
    _this.hasEnoughSpace = function () {
      var _a, _b;
      // The condition for the header to be able to be displayed in desktop mode (when in Viewport desktop)
      // is that both containers of the right side of the header have enough space (64px).
      return _this.checkMarginLeft((_a = _this.mainContainerRightTopRef) === null || _a === void 0 ? void 0 : _a.current) && _this.checkMarginLeft((_b = _this.mainContainerRightBottomRef) === null || _b === void 0 ? void 0 : _b.current);
    };
    _this.onResize = function () {
      // defer resizing to prevent browser from rerendering too much.
      requestAnimationFrame(function () {
        return _this.onResizeDeferred();
      });
    };
    _this.onResizeDeferred = function () {
      // Normally, the mobile/desktop functionality of eg. the PortalHeader is controlled by the
      // viewport (isMobile===false), but in edge cases, the desktop view does not fit (Layout broken)
      // So if there's not enough space, enforce mobile mode.
      // when we force mobile, we store the documentWidth so we are able to tell when to open it again.
      var hasEnoughSpace = _this.hasEnoughSpace();
      if (!_this.props.isMobile && !_this.state.forceMobile && !hasEnoughSpace) {
        _this.setState({
          forceMobile: true,
          forcedMobileWidth: document.documentElement.clientWidth
        }, function () {
          // also, inform the parent component e.g. the PortalHeader which has to do some extra stuff.
          _this.props.onForceMobileChange(_this.state.forceMobile);
        });
      } else if (_this.state.forceMobile && document.documentElement.clientWidth > _this.state.forcedMobileWidth) {
        _this.setState({
          forceMobile: false,
          forcedMobileWidth: 0
        }, function () {
          // also, inform the parent component e.g. the PortalHeader which has to do some extra stuff.
          _this.props.onForceMobileChange(_this.state.forceMobile);
        });
      }
    };
    _this.addBodyClasses = function () {
      var hasSecondLine = _this.props.bottomRight || _this.props.bottomLeft;
      var stageOffset = _this.props.isMobile && 16 || hasSecondLine && 32 || 22;
      document.body.classList.add("".concat(lsgPre, "stage__header-anchor-").concat(stageOffset));
      if (!_this.props.isSticky) {
        return;
      }
      var sectionOffset = _this.props.isMobile || hasSecondLine ? 16 : 22;
      document.body.classList.add("".concat(lsgPre, "section__header-anchor-").concat(sectionOffset));
    };
    _this.removeBodyClasses = function () {
      document.body.classList.remove("".concat(lsgPre, "section__header-anchor-16"));
      document.body.classList.remove("".concat(lsgPre, "section__header-anchor-22"));
      document.body.classList.remove("".concat(lsgPre, "stage__header-anchor-16"));
      document.body.classList.remove("".concat(lsgPre, "stage__header-anchor-22"));
      document.body.classList.remove("".concat(lsgPre, "stage__header-anchor-32"));
    };
    _this.onScrollChange = function () {
      var scrollPosition = Math.min(4 * 16, window.scrollY);
      if (scrollPosition !== _this.state.scrollPosition) {
        _this.setState({
          scrollPosition: scrollPosition
        });
      }
      _this.props.onScrollChangeCallback(scrollPosition);
    };
    _this.state = {
      forcedMobileWidth: 0
    };
    return _this;
  }
  _createClass(HeaderContainerWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addBodyClasses();
      addScrollCallback(this.onScrollChange);
      addResizeCallback(this.onResize);
      this.onResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeBodyClasses();
      removeScrollCallback(this.onScrollChange);
      removeResizeCallback(this.onResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var hadSecondLine = prevProps.bottomRight || prevProps.bottomLeft;
      var hasSecondLine = this.props.bottomRight || this.props.bottomLeft;
      if (prevProps.isMobile !== this.props.isMobile || hadSecondLine !== hasSecondLine || prevProps.isSticky !== this.props.isSticky) {
        this.removeBodyClasses();
        this.addBodyClasses();
      }
      if (!this.props.isMobile) {
        this.onResizeDeferred();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        scrollPosition = _this$state.scrollPosition,
        forceMobile = _this$state.forceMobile;
      var _this$props = this.props,
        bottomLeft = _this$props.bottomLeft,
        bottomRight = _this$props.bottomRight,
        isSticky = _this$props.isSticky;
      return /*#__PURE__*/React.createElement(HeaderContainerPresentation, Object.assign({}, this.props, {
        isMobile: forceMobile || this.props.isMobile,
        scrollPosition: (bottomLeft || bottomRight) && isSticky ? scrollPosition : undefined,
        mainContainerRightTopRef: this.mainContainerRightTopRef,
        mainContainerRightBottomRef: this.mainContainerRightBottomRef
      }));
    }
  }]);
  return HeaderContainerWrapper;
}(React.Component);
HeaderContainerWrapper.defaultProps = {
  onForceMobileChange: function onForceMobileChange() {
    /* empty */
  },
  onScrollChangeCallback: function onScrollChangeCallback() {
    /* empty */
  }
};

export { HeaderContainerWrapper };
